<template>
    <div class="page my">
        <my-skeleton v-if="loading" style="margin-bottom: 100vh"></my-skeleton>

        <div class="my-header">
            <div class="my-header-left">
                <img class="my-header-left-avatar" :src="user.avatar == '' ? '/static/img/web_broadcast_head.svg' : user.avatar" alt="" />
                <div style="display: inline-block;float: left">
                    <div class="my-header-title logined">
                        {{ user.name === '' ? user.nick_name : user.name }}
                        <img v-if="user.is_complete" src="/static/img/auth.svg" class="my-header-left-vip" alt="" />
                        <img v-else src="/static/img/unauth.svg" class="my-header-left-vip off" alt="" />
                    </div>
                    <div class="clear"></div>
                    <div class="my-header-desc" style="display: flex;">
                        <div v-for="(item,index) in identity">
                          <div v-if="user.identity === item.id">{{item.name}}</div>
                        </div>
                        <div class="my-header-bb">
                            <img src="/static/two/bb.svg" alt="" />
                            <span class="my-header-bb-point">{{ user.point }}博贝</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="my-header-right" @click="add_info()" v-if="user.is_complete == 1">
                <img src="/static/img/icon_mycenter_login.svg" style="width: 16px" alt="" />修改
            </div>
            <div class="my-header-right" @click="goLogin" v-else>
                <img src="/static/img/icon_mycenter_login.svg" style="width: 16px" alt="" />去认证
            </div>
            <div class="clear"></div>
        </div>

        <div class="my-list-nav">
            <div class="my-list-nav-item" @click="goHzsf">
                <img src="/static/two/pic_mycenter_1.svg" alt="" />
            </div>
            <div class="my-list-nav-item" @click="goZxzx">
                <img src="/static/two/pic_mycenter_2.svg" alt="" />
            </div>
            <div class="clear"></div>
        </div>

        <div class="control">
            <van-cell
                title-class="control-title"
                title="我的足迹"
                url="/vant/mobile.html"
                icon="/static/img/icon_mycenter_list_history.svg"
                icon-size="20px"
                :to="'/my-history'"
            />
            <van-cell
                title-class="control-title"
                title="我的收藏"
                to="index"
                icon="/static/img/icon_mycenter_list_favorite.svg"
                icon-size="20px"
                :to="'/my-favorite'"
            />
            <van-cell title-class="control-title" title="我的关注" icon="/static/img/focus.svg" icon-size="20px" :to="'/my-focus'" />
            <van-cell
                title-class="control-title"
                title="我的预约"
                url="/vant/mobile.html"
                icon="/static/img/icon_mycenter_list_order.svg"
                icon-size="20px"
                :to="'/my-list-order'"
            />
            <van-cell
                title-class="control-title"
                title="联系客服"
                icon="/static/img/icon_mycenter_list_service.svg"
                icon-size="20px"
                @click="toWechat"
            />
            <van-cell
                title-class="control-title"
                title="设置"
                url="/vant/mobile.html"
                icon="/static/img/icon_mycenter_list_setting.svg"
                icon-size="20px"
                :to="'/my-setting'"
            />
            <van-cell
                title-class="control-title"
                title="清除缓存"
                icon="/static/img/icon_mycenter_list_setting.svg"
                icon-size="20px"
                @click="goClear"
            />
        </div>

        <van-tabbar class="home-footer" :border="false" :fixed="true" :safe-area-inset-bottom="true" v-model="active" active-color="#D3172E">
            <van-tabbar-item to="/">
                <span class="home-footer-span">首页</span>
                <template #icon="props">
                    <div class="home-footer-icon-else">
                        <img src="/static/v4/icon_tab_home_2.svg" alt="" />
                    </div>
                </template>
            </van-tabbar-item>
            <van-tabbar-item to="live-list">
                <span class="home-footer-span">直播</span>
                <template #icon="props">
                    <div class="home-footer-icon">
                        <img src="/static/v4/icon_tab_live_2.svg" alt="" />
                    </div>
                </template>
            </van-tabbar-item>
            <van-tabbar-item to="clinic-course">
                <span class="home-footer-span">临床好课</span>
                <template #icon="props">
                    <div class="home-footer-icon">
                        <img src="/static/v4/icon_tab_course_2.svg" alt="" />
                    </div>
                </template>
            </van-tabbar-item>
            <van-tabbar-item to="my">
                <span class="home-footer-span-else">我的</span>
                <template #icon="props">
                    <div class="home-footer-icon-else">
                        <img src="/static/v4/icon_tab_me_1.svg" alt="" />
                    </div>
                </template>
            </van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
import Interface from '@/util/interface'
import mySkeleton from '@/skeleton/mySkeleton'
export default {
    name: 'my',
    components: {
        'my-skeleton': mySkeleton
    },
    data() {
        return {
            value: '',
            active: 2,
            banners: [],
            recommend: [],
            articles: [],
            user: {
                avatar: ''
            },
            loading: true,
            identity:[]
        }
    },
    methods: {
        goClear() {
            // 保留uuid 以防每次新增用户
            let uuid = localStorage.getItem('uuid') || ''
            localStorage.clear()
            sessionStorage.clear()
            localStorage.setItem('uuid', uuid)
            setTimeout(() => {
                this.$toast.success("操作成功");
                this.$router.go(0)
            }, 300);
            console.log('清除缓存-临时的')
        },
        fetch(scene) {
            if (scene === 'userinfo') {
                Interface.getData('get', Interface.user.user_info).then(res => {
                    if (res.code == 0) {
                        this.user = res.data
                    }
                    setTimeout(() => {
                        this.loading = false
                    }, 500)
                })
            }
            if (scene === 'identity') {
                Interface.getData('get', Interface.user.identity).then(res => {
                    if (res.code == 0) {
                        this.identity = res.data
                    }
                })
            }
        },
        goLogin() {
            sessionStorage.setItem('back-url', this.$route.path)
            this.$router.push({ name: 'login' })
        },
        add_info() {
            sessionStorage.setItem('back-url', this.$route.path)
            localStorage.setItem('update', 1)
            this.$router.push({ name: 'add-info', query: { update: 1 } })
            Interface.mFootPrint(2,42,'','',0, '我的-修改')
        },
        checkTo(n) {
            if (n === 0) {
                location.href = 'weixin://dl/business/?t=kBWDPWCQSvs'
            } else {
                location.href = 'weixin://dl/business/?t=bBpqluwmBGt'
            }
        },
        toWechat() {
            location.href = 'https://work.weixin.qq.com/kfid/kfc1ed5c3531beb6890'
        },
        goHzsf() {
            Interface.mFootPrint(4,42,'','',0, '我的-患者随访')
            location.href = 'https://byh-api.dr-gobroad.com/wechat-phase/urlLink?name=hzsf'
        },
        goZxzx() {
            Interface.mFootPrint(5,42,'','',0, '我的-在线咨询')
            location.href = 'https://byh-api.dr-gobroad.com/wechat-phase/urlLink?name=zxzx'
        }
    },
    created() {
        this.fetch('userinfo')
        this.fetch('identity')
        Interface.getShareInfo(this, '', '', '')
        Interface.mFootPrint(1,42,'','',0, '我的主页')
    }
}
</script>

<style lang="scss">
@import './index.scss';
</style>



// WEBPACK FOOTER //
// src/views/my/index.vue